import { useEffect } from "react";

function App() {
  useEffect(() => {
    // Redirect to the static HTML page
    window.location.replace('/prima-seiten.html');
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      background: '#fff'
    }}>
      <p>Wird geladen...</p>
    </div>
  );
}

export default App;
